<template>
    <div class="sidebar-wrapper">
        <div class="sidebar-dummy" :class="{'shrunk': !expanded}"></div>
        <div class="sidebar-menu transform-gpu -m-5 p-8 dark:border-gray-900"
             :class="{
                'shrunk items-center': !expanded && !overlay,
                'bg-white border-r z-50': overlay
            }">
            <div class="sidebar-container flex items-start transform-gpu justify-between" :class="{
                'pt-12': !expanded && !overlay
            }">
                <div class="bg-light-logo dark:bg-dark-logo rr-logo transform-gpu fixed" :class="{
                    '-rotate-90 -ml-14': !expanded && !overlay
                }"/>

            </div>

            <div class="flex grow flex-col gap-3 justify-center">
                <template v-for="(fieldset, f) in $page.props.menu" :key="f">
                    <template v-if="fieldset.id === 'main'">
                        <Link :href="item.link" class="sidebar-link "
                              v-for="(item, i) in fieldset.children" :key="i"
                              :class="{ 'opacity-75': item.link && $page.props.url !== item.link, 'disabled': item.disabled }">
                            <i :class="item.icon" style="font-size: 1.25rem"></i>
                            <template v-if="expanded || overlay">
                                <span :class="{'underline underline-roori-blue': item.link && $page.props.url === item.link,}">{{ item.title }}</span>
                                <div class="spacer"></div>
                                <span class="sidebar-tag" v-if="item.tag">{{ item.tag }}</span>
                            </template>
                        </Link>
                    </template>

                </template>
            </div>

            <div class="sidebar-container mt-12 flex flex-col justify-end">
                <div class="border dark:border-neutral-700 rounded-xl p-4 -m-2 flex gap-2" :class="{
                    'flex-col p-2 items-center gap-4' : !expanded && !overlay
                }">
                    <Avatar v-if="$page.props.user" :label="$page.props.user_initials" shape="circle" :image="profile?.url" class="border" size="normal"/>
                    <div v-if="expanded || overlay" class="grow">
                        <p class="text-sm font-bold">{{$page.props.user.name}}</p>
                        <p class="text-xs opacity-50">Roori Premium</p>
                    </div>
                    <Button text icon="pi pi-cog" severity="secondary" size="small"></Button>
                    <Button text icon="pi pi-sign-out" severity="secondary" @click="router.get('/logout')" size="small"></Button>
                </div>
            </div>
        </div>
    </div>
</template>
<script setup>
import {
    computed, inject, ref, watch
} from "vue"
import {Link, router, usePage} from '@inertiajs/vue3'
import Avatar from "primevue/avatar";
import Button from "primevue/button";
import _ from "lodash";

const profile = computed(() => {
    return usePage().props.user.profile;
})

const expanded = computed(() => (usePage().props.expandSidebar) ?? true);

const overlay = ref(false);

const setOverlay = _.debounce(() => {
    if (!expanded.value)
    {
        overlay.value = true;
    }
}, 20);
const leaveOverlay = () => {
    overlay.value = false;
}

watch(expanded, () => {
    overlay.value = false;
})
</script>
<style scoped lang="scss">
.rr-logo {
    margin-right: 20px;
    margin-top: 5px;
    height: 41px;
    background-repeat: no-repeat;
    width: 120px;
    transition: transform 0.3s cubic-bezier(0.4, 0, 0.2, 1);

    &.-rotate-90 {
        transform: rotate(-90deg);
    }
}

.sidebar-container {
    height: 200px
}

.sidebar-dummy {
    transition: width 0.3s cubic-bezier(0.4, 0, 0.2, 1);
    width: 300px;

    &.shrunk {
        width: 64px
    }
}

.sidebar-menu {
    width: 320px;


    &.shrunk {
        width: 64px;
        padding: 16px 0 16px 12px;
    }

    height: 100dvh;
    display: flex;
    position: fixed;
    flex-direction: column;
    gap: 6px;

    .v-spacer {
        height: 100%;
    }

    .fieldset-title {
        font-size: .75rem;
        font-weight: 600;
        line-height: 1.5rem;
        color: var(--text-color);
        margin-left: 10px;
        margin-bottom: -6px;
    }

    .sidebar-link {
        display: flex;
        align-items: center;
        gap: .75rem;
        font-weight: 600;
        color: var(--text-color);
        font-size: .875rem;
        cursor: pointer;
        padding: 0.5rem;
        border-radius: 6px;
        text-wrap: none;
        white-space: nowrap;

        &.m:not(:last-child) {
            margin-bottom: -10px;
        }

        i {
            color: var(--gray-400);
        }

        .spacer {
            width: stretch;
        }

        .sidebar-tag {
            font-size: .75rem;
            border: 1px solid var(--blue-300);
            background: var(--blue-50);
            color: var(--blue-400);
            border-radius: 6px;
            text-wrap: nowrap;
            padding: .15rem .3rem;
        }

        .custom-avatar {
            padding: 4px 6px;
            width: 24px;
            height: 24px;
            color: var(--surface-border);
            font-size: .75rem;
            border: 1px solid var(--surface-border);
            border-radius: 6px;
        }

        &.disabled {
            opacity: .4;
            cursor: not-allowed;
        }

        &:hover {
            color: var(--primary-color);

            i {
                color: var(--primary-color)
            }

            .custom-avatar {
                color: var(--primary-color);
                border: 1px solid var(--primary-color);
            }
        }

        &.active {
            color: var(--primary-color);

            i {
                color: var(--primary-color)
            }

        }
    }

    .legal {
        text-align: center;
        font-size: .75rem;
        opacity: .5;
        width: calc(300px - 32px);
    }
}
.sidebar-link span {
    transition: opacity 0.3s ease, transform 0.3s ease;
}

.sidebar-link span {
    &.underline {
        text-decoration: underline;
        text-decoration-thickness: 1px;
    }
}
.sidebar-menu {
    &.bg-white {
        transition: box-shadow 0.3s ease, background-color 0.3s ease;
        box-shadow: 0 2px 10px rgba(0, 0, 0, 0.1);
    }
}
.sidebar-link i {
    transition: transform 0.2s ease, color 0.2s ease;

    &:hover {
        transform: scale(1.1);
        color: var(--primary-color);
    }
}
.sidebar-link:hover i {
        transform: scale(1.1);
        color: var(--primary-color);
}
</style>
